import React, { memo, useState, useEffect, Fragment } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import Modal from 'components/Tvendo/Common/ModalBase';
import {
  Checkbox,
  FormControlLabel,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
} from '@material-ui/core';
import { wsUpdate } from 'services/WService';
import SweetAlert from 'react-bootstrap-sweetalert';

function ModalPricesUpdate(props) {
  const {
    model = undefined,
    purchase,
    setOpen,
    showNotify,
    purchaseId,
    reload,
    setAlert,
    classes,
  } = props;
  const { prices = [], products = [], priceLists = [] } = model;
  const [priceState, setPrices] = useState([]);
  const [noValidatePrices, setNoValidatePrices] = useState(false);
  const [priceComment, setPriceComment] = useState('');

  useEffect(() => {
    setPrices(prices);
  }, [model]);

  function handleChange(priceId, field, value) {
    setPrices((prices) => {
      let priceIndex = prices.findIndex((price) => price.id === priceId);
      let newPrices = [...prices];

      newPrices[priceIndex][field] = value;
      if (field === 'newUnitPrice') {
        newPrices[priceIndex]['newPackagePrice'] = parseFloat(
          (value / 100) * (100 - newPrices[priceIndex].discount).toFixed(4),
        );
      } else if (field === 'newPackagePrice') {
        newPrices[priceIndex]['newUnitPrice'] = parseFloat(
          ((value / (100 - newPrices[priceIndex].discount)) * 100).toFixed(4),
        );
      }

      return newPrices;
    });
  }

  function priceshasMarginErrors() {
    let errors = priceState.filter((price) => {
      let detail = purchase.details.find(
        (detail) => parseInt(detail.logi_product_id) === parseInt(price.logi_product_id),
      );

      let newPurchasePrice = detail.price / detail.NumPerMsr;
      let unitPrice = price.newUnitPrice || price.unit_price;
      let packagePrice = price.newPackagePrice || price.package_price;

      let newUnitMargin = ((unitPrice - newPurchasePrice) / newPurchasePrice) * 100;
      let newPackageMargin = ((packagePrice - newPurchasePrice) / newPurchasePrice) * 100;

      if (newUnitMargin < 5 || newPackageMargin < 5) return true;

      return false;
    });

    if (errors.length > 0) {
      return true;
    }

    return false;
  }

  async function submit() {
    if (!noValidatePrices) {
      if (priceshasMarginErrors()) {
        setAlert(
          <SweetAlert
            warning
            showCancel
            title="Hay diferencias en los margenes de ganancia"
            confirmBtnText=""
            cancelBtnText="Ok"
            cancelBtnCssClass={classes.button + ' ' + classes.danger}
            onCancel={() => setAlert(undefined)}
          />,
        );
        throw new Error('Error, mostrar alerta');
      }
    }

    let data = priceState.map((price) => {
      let data = { id: price.id };
      if (!!price.newUnitPrice) data.unit_price = price.newUnitPrice;
      if (!!price.newPackagePrice) data.package_price = price.newPackagePrice;
      return data;
    });

    let res = await wsUpdate('logi/price/massive-update/purchase', { purch_purchase_id: purchaseId, prices: data });
    if (res.success) {
      showNotify(res.message);
      let response = await wsUpdate(`purch/purchase/${purchaseId}/change-state`, {
        proc_status: 'V',
        force: 'Y',
        price_comment: priceComment,
      });
      if (response.success) {
        showNotify(response.message);
        reload();
      }
    } else {
      showNotify(res.message, 'error');
    }
  }

  return (
    <Modal
      title={`${prices.length} precios invalidos`}
      model={model}
      setOpen={setOpen}
      fullWidth
      maxWidth="lg"
      onSubmit={submit}
      saveButtonLabel="Guardar y validar"
      noValidate={true}
      footerComponent={
        <AllowedGuard
          permission={ConstantPermissions.PURCH_PURCHASES_NO_VALIDATE_PRICES}
          component={
            <TextField
              label="Comentario"
              value={priceComment}
              onChange={(e) => setPriceComment(e.target.value)}
            />
          }
        >
          <>
            <TextField
              label="Comentario"
              value={priceComment}
              required
              onChange={(e) => setPriceComment(e.target.value)}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={noValidatePrices}
                  onChange={() => setNoValidatePrices((checked) => !checked)}
                />
              }
              label={'No validar márgenes'}
            />
          </>
        </AllowedGuard>
      }
    >
      <Table>
        <TableHead>
          <TableRow>
            <TableCell rowSpan={2}>Producto / Lista precios</TableCell>
            {priceLists.map((priceList) => {
              return (
                <TableCell colSpan={2} key={priceList.id} align="center">
                  {priceList.ListName}
                </TableCell>
              );
            })}
          </TableRow>
          <TableRow>
            {priceLists.map((priceList) => {
              return (
                <Fragment key={priceList.id}>
                  <TableCell align="center">Precio unitario</TableCell>
                  <TableCell align="center">Precio paquete</TableCell>
                </Fragment>
              );
            })}
          </TableRow>
        </TableHead>
        <TableBody>
          {products.map((product) => {
            let detail = purchase.details.find(
              (detail) => parseInt(detail.logi_product_id) === parseInt(product.id),
            );
            return (
              <TableRow key={product.id}>
                <TableCell>
                  ({product.ItemCode}) {product.ItemName} <br />
                  <Tooltip title={`Último precio de compra`}>
                    <span>S/{parseFloat(product.last_purchase_price).toFixed(4)}</span>
                  </Tooltip>
                  {' -> '}
                  <Tooltip title={`Nuevo precio de compra`}>
                    <span>S/{parseFloat(detail.price / detail.NumPerMsr).toFixed(4)}</span>
                  </Tooltip>
                </TableCell>

                {priceState.length > 0 &&
                  priceLists.map((priceList, index) => {
                    let price = priceState.find((price) => {
                      return (
                        parseInt(price.logi_price_list_id) === parseInt(priceList.id) &&
                        parseInt(price.logi_product_id) === parseInt(product.id)
                      );
                    });

                    if (price === undefined) {
                      return (
                        <Fragment key={index}>
                          <TableCell>-</TableCell>
                          <TableCell>-</TableCell>
                        </Fragment>
                      );
                    }

                    let newPurchasePrice = detail.price / detail.NumPerMsr;
                    let unitPrice =
                      price.newUnitPrice === undefined ? price.unit_price : price.newUnitPrice;
                    let packagePrice =
                      price.newPackagePrice === undefined
                        ? price.package_price
                        : price.newPackagePrice;

                    let newUnitMargin = ((unitPrice - newPurchasePrice) / newPurchasePrice) * 100;
                    let newPackageMargin =
                      ((packagePrice - newPurchasePrice) / newPurchasePrice) * 100;

                    let unitMargin = 0;
                    if (price.unit_margin !== null) {
                      unitMargin = price.unit_margin.toFixed(2);
                    }
                    let packageMargin = 0;
                    if (price.package_margin !== null) {
                      price.package_margin.toFixed(2);
                    }

                    let unitColor = 'red';
                    if (newUnitMargin > 5 && newUnitMargin < 10) {
                      unitColor = 'yellow';
                    } else if (newUnitMargin >= 10) {
                      unitColor = '#2cda00'; // Verde
                    }

                    let packageColor = 'red';
                    if (newPackageMargin > 5 && newPackageMargin < 10) {
                      packageColor = 'yellow';
                    } else if (newPackageMargin >= 10) {
                      packageColor = '#2cda00'; // Verde
                    }

                    return (
                      <Fragment key={price.id}>
                        <TableCell>
                          <TextField
                            type="number"
                            value={unitPrice}
                            fullWidth
                            onChange={(e) => {
                              let value = e.target.value;
                              if (value === '') {
                                value = 0;
                              }
                              handleChange(price.id, 'newUnitPrice', value);
                            }}
                            inputProps={{ min: 0, step: 0.0001 }}
                            InputProps={{
                              endAdornment: (
                                <Tooltip title={`${unitMargin}%`}>
                                  <div
                                    style={{
                                      color: unitColor,
                                      textShadow: '0 0 2px #000',
                                    }}
                                  >
                                    {newUnitMargin.toFixed('2')}%
                                  </div>
                                </Tooltip>
                              ),
                            }}
                          />
                        </TableCell>
                        <TableCell>
                          <Tooltip title="Descuento paquete">
                            <span>{parseFloat(price.discount).toFixed(2)}%</span>
                          </Tooltip>
                          <TextField
                            type="number"
                            value={packagePrice}
                            fullWidth
                            onChange={(e) => {
                              let value = e.target.value;
                              if (value === '') {
                                value = 0;
                              }
                              handleChange(price.id, 'newPackagePrice', value);
                            }}
                            inputProps={{ min: 0, step: 0.0001 }}
                            InputProps={{
                              endAdornment: (
                                <Tooltip title={`${packageMargin}%`}>
                                  <div
                                    style={{
                                      color: packageColor,
                                      textShadow: '0 0 2px #000',
                                    }}
                                  >
                                    {newPackageMargin.toFixed('2')}%
                                  </div>
                                </Tooltip>
                              ),
                            }}
                          />
                        </TableCell>
                      </Fragment>
                    );
                  })}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </Modal>
  );
}

export default memo(ModalPricesUpdate);
